import axios from 'axios'
import { urlTehamaAgent, urlTehamaStatus } from '../database/apiUrls';
import SecondServer from '../database/SecondServer';
import { siteAccessCode } from '../database/apiv2SiteAccessor';
import { pollUntilDone, checkJobStatus } from '../Sites/SiteConfig';

export async function OpenAI(text) {
 try {
    // Call the LLM API (using OpenAI's API as an example)
    const response = await axios.post(
      'https://api.openai.com/v1/engines/text-davinci-003/completions',
      {
        prompt: text,
        max_tokens: 150,
      },
      {
        headers: {
          'Authorization': `Bearer ${process.env.OPENAI_API_KEY}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response //res.json({ response: response.data.choices[0].text.trim() });
  } catch (error) {
    console.error(error);
    return error
    //res.status(500).json({ error: 'Error processing your request.' });
  }
 }

 export async function Gemini(text) {
  const apiKey = process.env.REACT_APP_GEMINI;
  try {
  const response = await axios.post(
    'https://generativelanguage.googleapis.com/v1beta/models/gemini-flash-latest:generateContent',
    {
      "contents": [
        {
          "parts": [
          {
            "text": text
          }
          ]
        }
      ]
    },
    {
      headers: {
        'X-goog-api-key': apiKey,
        'Content-Type': 'application/json',
      },
    }
  );
  return response 
  } catch (error) {
    console.error(error);
    return error
  }
}

function AgentAPIConfig () {
  return ({
    submitURL: urlTehamaAgent(),
    statusURL: urlTehamaStatus(),
    pollIntervalMS: 2000,   // 2s
    maxPollAttempts: 150,
  })
}
export async function TehamaAI (props, text, sessionID) {
  //console.log (props)
  const config = AgentAPIConfig()
  const ss = new SecondServer(props)
  const resp = ss.apiInsertData(config.submitURL, 
    {input_text: text, 
      query_type: "agentcore",
      access_code: siteAccessCode(props.getActiveSite()),
      session_id: sessionID
    })
  return resp
}
export async function TehamaAIImage (props, text, encodedImage) {
  const config = AgentAPIConfig()
  const ss = new SecondServer(props)
  const resp = ss.apiInsertData(config.submitURL, 
    {input_text: text, 
      query_type: "agentcore",
      access_code: siteAccessCode(props.getActiveSite()),
      image: encodedImage,
    })
  return resp
}
export async function PollAIJob(props, jobId, cancelPoll) {
  const ss = new SecondServer(props)
  try {
    const resp = await pollUntilDone(() => checkJobStatus(ss, jobId), {}, cancelPoll.signal)
    console.log (resp)
    return resp
  }
  catch (err) {
    console.log (err)
    return err
  }
}

// ref
///https://github.com/TehamaWireless/tehama-c2-ios/blob/d99f75957aae5020344c94138ef4a8f586ff673d/Tehama%20C2/Claude/TehamaAgentService.swift
